const API_URL = process.env.REACT_APP_BACKEND_URL;

export function fetchAdmin(url, opts = {}) {
  return fetch(`${API_URL}${url}`, { credentials: "include", ...opts });
}

export function jsonHeaders() {
  return { "Content-Type": "application/json" };
}
